<div class="min-h-[100dvh] bg-[#fcfaf7] flex flex-col font-sans text-[#1f1b16]">
  <header class="sticky top-0 z-20 bg-[#fcfaf7]/90 backdrop-blur-md border-b border-black/5">
    <div class="max-w-2xl mx-auto px-4 py-3 flex items-center justify-center relative">
      <button
        type="button"
        (click)="goBack()"
        class="absolute left-4 text-sm font-medium text-[#3a332c]/70 hover:text-black"
      >
        Volver
      </button>

      <h1 class="text-base font-bold tracking-tight">Unirse</h1>
    </div>
  </header>

  <main class="flex-1 w-full max-w-2xl mx-auto px-4 py-6">
    <section class="space-y-6">
      <div class="flex items-start gap-4">
        <div class="flex h-20 w-20 shrink-0 items-center justify-center">
          <img
            src="https://res.cloudinary.com/dgjd3ybs1/image/upload/v1772476007/logo-dinno-chef_ybshqf.png"
            alt="Dinno"
            class="h-full w-full object-contain"
          />
        </div>

        <div class="flex-1 rounded-[2rem] bg-white border border-black/5 px-5 py-4 shadow-sm">
          <h2 class="text-2xl font-bold tracking-tight text-[#1f1b16]">
            @if (loadingPreview()) {
              Cargando invitación...
            } @else {
              Te uniste a {{ splitTitle() }}
            }
          </h2>

          <p class="mt-1 text-lg text-[#3a332c]/65">¿Cómo te llamás?</p>
        </div>
      </div>

      <section class="rounded-[2rem] border border-black/[0.05] bg-white px-4 py-6 shadow-sm">
        <input
          type="text"
          [ngModel]="name()"
          (ngModelChange)="name.set($event)"
          (keydown.enter)="join()"
          placeholder="Tu nombre"
          class="w-full rounded-2xl border border-black/10 bg-white px-4 py-4 text-2xl text-center text-[#1f1b16] outline-none focus:border-orange-400 transition-all placeholder:text-[#3a332c]/25"
        />
      </section>

      @if (!loadingPreview() && !canJoin()) {
        <section class="rounded-[2rem] border border-amber-200 bg-amber-50 px-4 py-4 shadow-sm">
          <p class="text-sm font-medium text-amber-800">
            Esta división ya no acepta nuevos participantes.
          </p>
        </section>
      }
    </section>
  </main>

  <footer class="sticky bottom-0 bg-[#fcfaf7] border-t border-black/5 px-4 py-4">
    <div class="max-w-2xl mx-auto">
      <button
        type="button"
        (click)="join()"
        [disabled]="loadingPreview() || !isFormValid() || saving() || !canJoin()"
        class="w-full rounded-2xl py-4 font-bold shadow-md transition-all active:scale-[0.98]"
        [class.bg-gradient-to-r]="!loadingPreview() && isFormValid() && !saving() && canJoin()"
        [class.from-orange-500]="!loadingPreview() && isFormValid() && !saving() && canJoin()"
        [class.to-amber-500]="!loadingPreview() && isFormValid() && !saving() && canJoin()"
        [class.text-white]="!loadingPreview() && isFormValid() && !saving() && canJoin()"
        [class.bg-[#f4b290]]="loadingPreview() || !isFormValid() || saving() || !canJoin()"
        [class.text-white/80]="loadingPreview() || !isFormValid() || saving() || !canJoin()"
      >
        {{ saving() ? 'Uniéndote...' : 'Continuar →' }}
      </button>
    </div>
  </footer>
</div>
